import React from 'react';
import { number } from 'prop-types';
import { useSelector } from 'react-redux';
import DynamicIcon from 'components/DynamicIcon';

Logos.propTypes = {
  floorLevel: number,
  rotate: number,
};

function Logos(props) {
  const { floorLevel, rotate } = props;
  const targetProperty = floorLevel + 'F';
  const state = useSelector(state => state.logosCoors)
  const logos = state[targetProperty] || [];
  return (
    <>
      {logos?.map(({href, logoSize, cx, cy}, index) => (
        <DynamicIcon
          logoRectSize={logoSize || 40}
          key={index}
          rotate={rotate}
          href={href}
          x={cx}
          y={cy}
        />
      )
      )}
    </>
  );
}

export default Logos;